import { Component, EventEmitter, Input, Output } from '@angular/core';

import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-confirm-dialog',
    imports: [
    FormsModule
],
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {
  @Input() modalTitle?: string;
  @Input() modalText?: string;
  @Output() modalCancel: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  @Output() modalYes: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  @Output() modalNo: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  close(event: MouseEvent) {
    this.modalCancel.emit(event);
  }

  yes(event: MouseEvent) {
    this.modalYes?.emit(event);
  }

  no(event: MouseEvent) {
    this.modalNo?.emit(event);
  }
}
